import { form } from 'stores';

import { REGISTRATION_FORM } from '../../constants';

import { fieldIdUtils } from '../../utils';

import { changeDistanceConditions } from '../../selectors/changeDistanceConditions';

/**
 * @description
 * lock the registration email to the address the change distance
 * invitation was raised against
 */
function initFormDataFromChangeDistance() {
  const racerEmail = changeDistanceConditions.racerEmail.get();

  if (!racerEmail) {
    return;
  }

  form.onChange(REGISTRATION_FORM, fieldIdUtils.registrationLeaderEmail(), racerEmail);
}

export { initFormDataFromChangeDistance };
